import { render, staticRenderFns } from "./WidgetNightsPerChains.vue?vue&type=template&id=cb7fc61a&scoped=true"
import script from "./WidgetNightsPerChains.vue?vue&type=script&lang=js"
export * from "./WidgetNightsPerChains.vue?vue&type=script&lang=js"
import style0 from "./WidgetNightsPerChains.vue?vue&type=style&index=0&id=cb7fc61a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7fc61a",
  null
  
)

export default component.exports